import { inject, Injectable } from "@angular/core";
import { AccessRightsService } from "../access-rights/access-right.service";
import { ActionPermission } from "../access-rights/actions";

@Injectable({
  providedIn: 'root'
})
export class CareersRoutingService {
  private _accessRightsService = inject(AccessRightsService);

  /**
   * Get logged in user default route URL based on access rights (by order of access rights)
   * @returns Default route URL
   */
  public getCurrentUserDefaultAppRouteURL(): string {
    const hasDashboardAccess = this._accessRightsService.hasAccessTo(ActionPermission.viewDashboard);
    if (hasDashboardAccess) {
      return '/home';
    }

    const hasViewRequisitionsAccess = this._accessRightsService.hasAccessTo(ActionPermission.viewRequisitions);
    if (hasViewRequisitionsAccess) {
      return '/job-requisitions/my-list';
    }

    const hasViewHiringRequestsAccess = this._accessRightsService.hasAccessTo(ActionPermission.viewHiringRequests);
    if (hasViewHiringRequestsAccess) {
      return '/hiring-requests/list';
    }

    const hasViewCandidatesAccess = this._accessRightsService.hasAccessTo(ActionPermission.viewCandidates);
    if (hasViewCandidatesAccess) {
      return '/candidates/list';
    }

    const hasGenerateReportsAccess = this._accessRightsService.hasAccessTo(ActionPermission.generateReports);
    if (hasGenerateReportsAccess) {
      return '/reports/list';
    }

    const hasManageSettingsAccess = this._accessRightsService.hasAccessTo(ActionPermission.manageSettings);
    if (hasManageSettingsAccess) {
      return '/settings/continents';
    }

    const hasCreateRequisitionAccess = this._accessRightsService.hasAccessTo(ActionPermission.createRequisition);
    if (hasCreateRequisitionAccess) {
      return '/job-requisitions/new';
    }

    const hasCreateHiringRequestAccess = this._accessRightsService.hasAccessTo(ActionPermission.createHiringRequest);
    if (hasCreateHiringRequestAccess) {
      return '/hiring-requests/new';
    }

    return '';
  }
}
